import $ from 'jquery';

$(document).ready(function () {
    // overlay for comparison table
    // would have been pure CSS, but we had to handle IE
    if ($('.comparison-table').length) {
        // Create our clone-able element
        var span = $("<span></span>").addClass("overlay");

        // Add cloned <span> elements at beginning/end of all .testTD cells
        $(".comparison-table tbody td:nth-child(2)").prepend(span.clone());

        // If the user is in Internet Explorer, avoid table-cell height bug
        if (document.documentMode && document.documentMode < 12) {
            $(".comparison-table td .overlay").height(function () {
                return $(this).parent().outerHeight();
            });
        }
    }
});